var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"download-btn",attrs:{"disabled":_vm.isDownloading},on:{"click":_vm.handleDownloadReports}},[(!_vm.isDownloading)?_c('span',[_vm._v("下载最新周报")]):_vm._e(),(_vm.isDownloading)?_c('span',[_vm._v("下载中...")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }